import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const ChannelShow = (props) => (
        <ShowGuesser {...props} resource="channels"/>
);

export default ChannelShow;
